export default __webpack_public_path__ + "static/media/enghien09.238f8903.jpg";